import { type Update } from '@ngrx/entity';
import { createAction, props } from '@ngrx/store';

import { type Notification } from './notification.interfaces';

const NOTIFICATION_PREFIX = 'notification';

export const appendNotification = createAction(
  `${NOTIFICATION_PREFIX}/APPEND`,
  props<Notification>(),
);

export const notifySuccess = createAction(
  `${NOTIFICATION_PREFIX}/NOTIFY_SUCCESS_MESSAGE`,
  props<{ message: string }>(),
);

export const notifyError = createAction(
  `${NOTIFICATION_PREFIX}/NOTIFY_ERROR_MESSAGE`,
  ({ message }: { message: string }) => ({
    message,
    error: new Error(message),
  }),
);

export const notifyInfo = createAction(
  `${NOTIFICATION_PREFIX}/NOTIFY_INFO_MESSAGE`,
  props<{ message: string }>(),
);

export const notifyWarning = createAction(
  `${NOTIFICATION_PREFIX}/NOTIFY_WARNING_MESSAGE`,
  props<{ message: string }>(),
);

export const destroyNotificationRequest = createAction(
  `${NOTIFICATION_PREFIX}/DESTROY_REQUEST`,
  props<Update<Notification>>(),
);

export const destroyNotificationSuccess = createAction(
  `${NOTIFICATION_PREFIX}/DESTROY_SUCCESS`,
  props<{ id: number }>(),
);

export const destroyNotificationError = createAction(
  `${NOTIFICATION_PREFIX}/DESTROY_ERROR`,
  props<{ id: number }>(),
);
